var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Component } from 'react';
import { Button as RButton, Label } from 'reactstrap';
import theme from '../../../Theme';
import { Field, FieldType } from '../../../elements';
import { T, t } from '../../../helpers/i18n';
import cxs from 'cxs/component';
import history from '../../../helpers/History';
import { Table } from '../../../components';
import { ButtonsBar, StyledButton } from '../../../Styles';
var AcountContainer = /** @class */ (function (_super) {
    __extends(AcountContainer, _super);
    /*
      componentDidMount() {
        console.log('componentDidMount')
      }
    
      componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        console.log('componentDidUpdate')
      }
    */
    function AcountContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (name, value, column) {
            var _a;
            var result = (_a = {}, _a[column ? column : name] = value, _a);
            // @ts-ignore
            _this.setState(__assign({}, result), function () {
                // console.log('state: ', this.state)
            });
        };
        _this.handleSubmit = function () {
            var _a;
            var acount = _this.props.acount;
            if (acount.collaborator && _this.state.beCollaborator === !!!((_a = acount.collaborator) === null || _a === void 0 ? void 0 : _a.disabled_at)) {
                return _this.props.store.UI.newWarning(T('nothingModified'));
            }
            if (acount.collaborator) {
                /*if (acount.collaborator.disabled_at === null && this.state.beCollaborator ||
                  acount.collaborator.disabled_at !== null && !this.state.beCollaborator)  {
                  this.props.store.UI.newWarning('nada cambiado')
                  return
                }*/
                acount.collaborator.disabled_at = _this.state.beCollaborator ? null : new Date();
                _this.props.store.acountStore.patch(acount).then(function (value) {
                    _this.props.store.UI.newWarning(T('saved'));
                    history.goBack();
                }).catch(function (error) {
                });
            }
            else {
                _this.props.store.acountStore.create({
                    client_id: acount.id,
                    disabled_at: !_this.state.beCollaborator
                }).then(function (value) {
                    _this.props.store.UI.newWarning(T('saved'));
                    history.goBack();
                }).catch(function (error) {
                });
            }
        };
        _this.state = {
            beCollaborator: _this.props.acount.collaborator ? !!!_this.props.acount.collaborator.disabled_at : false
        };
        return _this;
    }
    AcountContainer.prototype.render = function () {
        var _a, _b, _c;
        var acount = this.props.acount;
        var beCollaborator = this.state.beCollaborator;
        var headerOperators = ['name'];
        var operatorsItems = (_a = acount.operators) === null || _a === void 0 ? void 0 : _a.map(function (operator) {
            return {
                id: operator.client.id,
                name: operator.client.name
            };
        });
        var headerCollaborators = ['name'];
        var collaboratorsItems = acount.collaborators.map(function (operator) {
            return {
                id: operator.client.id,
                name: operator.client.name
            };
        });
        return (React.createElement("div", { style: {
                marginTop: '20px',
            } },
            (!acount.collaborator || !!acount.collaborator.disabled_at) &&
                React.createElement("p", { style: {
                        margin: '30px',
                        color: theme.color.primary,
                        fontSize: 'large'
                    } }, T('noCollaborator')),
            React.createElement(Field, { field: {
                    name: 'beCollaborator',
                    type: FieldType.Checkbox,
                    value: beCollaborator,
                    size: 3
                }, onChange: this.handleChange }),
            acount.collaborator && !((_b = acount.collaborator) === null || _b === void 0 ? void 0 : _b.disabled_at) && React.createElement(Field, { field: {
                    name: 'collaboratorCode',
                    type: FieldType.Label,
                    value: acount.collaborator ? acount.collaborator.codeCollaborator : '',
                    size: 3,
                    underline: false
                }, onChange: function () {
                } }),
            !((_c = acount.collaborator) === null || _c === void 0 ? void 0 : _c.disabled_at) && !!acount.collaborator && (!acount.operators || acount.operators.length === 0) &&
                React.createElement("div", null,
                    React.createElement(Label, null, T('noOperators'))),
            acount.operators && acount.operators.length > 0 &&
                React.createElement(WrapperDivTable, null,
                    React.createElement("div", { style: {
                            minWidth: '75%'
                        } },
                        React.createElement(Label, null, 'proveedor de servicios donde soy colaborador'),
                        React.createElement(Table, { noMinHeight: true, style: {
                                border: "1px solid ".concat(theme.color.hairline),
                            }, search: false, header: headerOperators, keyExtractor: function (item) { return String(item.id); }, items: operatorsItems }))),
            acount.collaborators && acount.collaborators.length > 0 &&
                React.createElement(WrapperDivTable, null,
                    React.createElement("div", { style: {
                            marginTop: '25px',
                            minWidth: '75%'
                        } },
                        React.createElement(Label, null, 'colaboradores'),
                        React.createElement(Table, { noMinHeight: true, style: {
                                border: "1px solid ".concat(theme.color.hairline),
                            }, search: false, header: headerCollaborators, keyExtractor: function (item) { return String(item.id); }, items: collaboratorsItems }))),
            React.createElement(ButtonsBar, null,
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    };
    AcountContainer = __decorate([
        inject('store'),
        observer,
        loading(function (props) { return [
            props.store.acountStore.read().then(function (acount) { return ({ acount: acount }); })
        ]; })
    ], AcountContainer);
    return AcountContainer;
}(Component));
export default AcountContainer;
var WrapperRButton = function (props) {
    console.log('WrapperRButton - props: ', props);
    var selected = props.selected, onClick = props.onClick;
    return React.createElement(RButton, { outline: true, style: {
            color: selected ? theme.color.primary : undefined
        }, onClick: onClick }, props.children);
};
var WrapperDivTable = cxs('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/ModuleCollaborator.tsx
// module id = 1577
// module chunks = 0